import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "shield-yes-o",
  "use": "shield-yes-o-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"shield-yes-o\"><defs><style>#shield-yes-o .cls-1{fill:none}</style></defs><title>资源 48</title><g id=\"shield-yes-o_图层_2\" data-name=\"图层 2\"><g id=\"shield-yes-o_图层_1-2\" data-name=\"图层 1\"><path id=\"shield-yes-o_Rectangle_45_Copy\" data-name=\"Rectangle 45 Copy\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /><g id=\"shield-yes-o_Safety\"><path id=\"shield-yes-o_Shape\" d=\"M3 13.5v-9l9-3 9 3v9a9 9 0 0 1-18 0zm1.69-7.74v7.74a7.31 7.31 0 0 0 14.62 0V5.76L12 3.19zm6.07 9.65v-.05l-3-3a.84.84 0 1 1 1.17-1.21l2.45 2.45L15.93 9a.8.8 0 0 1 1.13 0l.07.07a.81.81 0 0 1 0 1.12l-5.24 5.24a.8.8 0 0 1-1.13-.02z\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/shield-yes-o.svg
// module id = 1b4q
// module chunks = 6